import { Typography } from '@mui/material'
import { OverviewListFilters } from '../OverviewListFilters'
import * as S from './PageHeaderAndFilters.style'

export const PageHeaderAndFilters = () => (
  <>
    <S.Header>
      <Typography variant='h5' fontWeight='bold'>Lista de Recebimentos</Typography>
    </S.Header>

    <OverviewListFilters />
  </>
)
